export const buildSubCompanyCreatePayload = (values, {preferGeocodingForLocation = false} = {}) => {
    const {subCompanyCode, zoneInfo, zoneId, city, county, district, ...rest} = values;

    return {
        ...rest,
        ...(preferGeocodingForLocation ? {} : {city, county, district}),
        zoneInfo: {zoneId: null},
    };
};

export const buildSubCompanyUpdatePayload = (values, initialData) => {
    const {subCompanyCode, zoneInfo, zoneId, ...rest} = values;
    const locationOrAddressChanged =
        rest.city !== initialData?.city ||
        rest.county?.toLocaleLowerCase("tr-TR") !==
            initialData?.county?.toLocaleLowerCase("tr-TR") ||
        rest.location?.latitude !== initialData?.location?.latitude ||
        rest.location?.longitude !== initialData?.location?.longitude;

    return {
        ...rest,
        zoneInfo: {
            zoneId: locationOrAddressChanged ? null : zoneId ?? null,
        },
    };
};
